import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const ViewSkillBasedQueuePageMenu = () => {
  const { getSingleEntityUrl } = useSkillBasedQueueUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} />
    </SidebarStickyMenu>
  );
};

export default ViewSkillBasedQueuePageMenu;
